<template>
  <div>
    <v-dialog v-model="show">
      <v-card>
        <v-card-title class="d-flex" style="position: relative"
                      :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
          <h2>{{editedIndexDispatchOrder > -1 ? 'Edit dispatch order ' + dispatchOrder.id : 'New dispatch order'}}</h2>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text>
          <v-container container--fluid grid-list-xl pb-0>
            <v-form
              ref="form"
              v-model="valid">
              <v-row justify="space-between">
                <v-col md="3" cols="12">
                  <div v-if="editedIndexDispatchOrder > -1" class="client-name">
                    <div style="font-size: 14px;">Client Name</div>
                    <div style="font-size: 18px;">{{dispatchOrder.client_name ? dispatchOrder.client_name :'-'}}</div></div>
                  <v-autocomplete v-else
                    :items="clients"
                    v-model="dispatchOrder.client_id"
                    item-text="name"
                    item-value="id"
                    label="Pick a client..."
                    prepend-icon="fas fa-user"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-dialog
                    ref="dialogDateDispatchOrder"
                    v-model="modalDateDispatchOrder"
                    :return-value.sync="dispatchOrder.date"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="dispatchOrder.date"
                        label="Dispatch date"
                        prepend-icon="event"
                        v-on="on"
                        required
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dispatchOrder.date"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="blue darken-1" @click="modalDateDispatchOrder = false">Cancel</v-btn>
                      <v-btn text color="blue darken-1" @click="$refs.dialogDateDispatchOrder.save(dispatchOrder.date)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col md="3" cols="12">
                  <v-menu
                    v-model="etaDialog"
                    ref="etaDialog"
                    offset-y
                    :close-on-content-click="false"
                    :return-value.sync="dispatchOrder.eta"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        prepend-icon="access_time"
                        v-model="dispatchOrder.eta"
                        readonly
                        label="Estimated line haul arrival time"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="etaDialog"
                      format="24hr"
                      @click:minute="$refs.etaDialog.save(dispatchOrder.eta)"
                      :allowed-minutes="allowedMinutes"
                      v-model="dispatchOrder.eta"
                    ></v-time-picker>
                  </v-menu>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="local_mall"
                    v-model="dispatchOrder.number"
                    label="Reference number"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                <v-select
                  label="Choose a depot"
                  :items="depots"
                  item-text="name"
                  item-value="id"
                  v-model="dispatchOrder.depot_id"
                  prepend-icon="fas fa-warehouse"
                ></v-select>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="person"
                    v-model="dispatchOrder.receiver_name"
                    label="Receiver name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="place"
                    v-model="dispatchOrder.receiver_address"
                    label="Receiver address"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="place"
                    v-model="dispatchOrder.receiver_suburb"
                    label="Receiver suburb"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="place"
                    v-model="dispatchOrder.receiver_state"
                    label="Receiver state"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="place"
                    v-model="dispatchOrder.receiver_postcode"
                    label="Receiver postcode"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="local_mall"
                    v-model="dispatchOrder.receiver_reference"
                    label="Receiver reference"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-switch
                    class="justify-center"
                    color="blue"
                    v-model="dispatchOrder.exchange_pallets"
                    label="Exchange pallets"
                  ></v-switch>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="emoji_transportation"
                    v-model="dispatchOrder.carrier"
                    label="Carrier name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="local_mall"
                    v-model="dispatchOrder.carrier_reference"
                    label="Carrier reference"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="fas fa-pallet"
                    v-model="dispatchOrder.num_pallets"
                    label="Total number of pallets to be received"
                    type="number"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row class="justify-center">
                <v-col md="6" cols="12">
                  <v-textarea
                    prepend-icon="notes"
                    v-model="dispatchOrder.notes"
                    outlined
                    name="input-7-4"
                    label="Some text..."
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
            <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col cols="2" class="text-center">
                <v-btn
                  text
                  @click="$emit('close');$emit('updateDataTable');"
                  color="blue-grey lighten-2"
                >Cancel
                </v-btn>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-btn
                  text
                  @click="$emit('save');"
                  color="blue darken-1"
                  :disabled="isSaved && editedIndexDispatchOrder === -1"
                >Save
                </v-btn>
              </v-col>
              <v-col cols="2" class="text-center" v-if="isSaved || editedIndexDispatchOrder > -1">
                <v-btn
                  text
                  @click="$emit('openItemsDialog');"
                  color="indigo"
                >Items
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="700px" v-model="itemsDialog">
      <v-card>
        <v-card-title>
          <h3>Receive order items</h3>
          <v-spacer></v-spacer>
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn text large @click="updateDataTable" v-on="on">
                <v-icon color="cyan darken-2">refresh</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn fab small color="warning" v-on="on" class="elevation-2 align-center">
                <v-icon @click="newItem">add</v-icon>
              </v-btn>
            </template>
            <span>Add an item</span>
          </v-tooltip>
        </v-card-title>

        <v-divider color="#42a5f5"></v-divider>

        <v-data-table
          :headers="headers"
          :items="renderedDispatchOrderItems"
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
              <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers"
                  :key="index">{{props.item[header.value]}}
              </td>
              <td v-else style="text-align: center">
<!--                <v-tooltip top color="secondary">-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                    <v-icon color="blue" v-on="on">-->
<!--                      edit-->
<!--                    </v-icon>-->
<!--                  </template>-->
<!--                  <span>Edit</span>-->
<!--                </v-tooltip>-->
<!--                <v-tooltip top color="secondary">-->
<!--                  <template v-slot:activator="{ on }">-->
<!--                    <v-icon color="red" v-on="on" class="pl-1">-->
<!--                      delete-->
<!--                    </v-icon>-->
<!--                  </template>-->
<!--                  <span>Delete</span>-->
<!--                </v-tooltip>-->
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="$emit('closeItem');">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="450px" v-model="addItemDialog">
      <v-card>
        <v-card-title>
          <h3>{{editedIndex > -1 ? 'Edit item No' + editedItem.id + 'from dispatch order No ' + dispatchOrder.id : 'Add an item to dispatch order No ' + dispatchOrder.id }} </h3>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-row>
            <v-select
              label="Choose an item"
              :items="items"
              item-text="name"
              item-value="id"
              v-model="editedItem.item_id"
            ></v-select>
          </v-row>
          <v-row>
            <v-text-field
              label="Quantity"
              v-model="editedItem.quantity"
              type="number"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              label="Serial"
              v-model="editedItem.serial"
            ></v-text-field>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="red" @click="closeAddItemDialog">Cancel</v-btn>
          <v-btn text color="primary" @click="saveChanges">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this item. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="DeleteItem" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "CreateDispatchOrder",
        props: {
            createDispatchOrderDialog: Boolean,
            dispatchOrder: Object,
            itemsDialog: Boolean,
            editedIndexDispatchOrder: Number,
            isSaved: Boolean,
        },
        data() {
            return {
                valid: false,
                modalDateDispatchOrder: false,
                etaDialog: false,
                depots: null,
                clients: null,
                addItemDialog: null,
                editedIndex: -1,
                loading: false,
                items: null,
                headers: [
                    {text: 'ID', value: 'item_id', align: 'center', sortable: false},
                    {text: 'Name', value: 'name', align: 'center', sortable: false},
                    {text: 'Quantity', value: 'quantity', align: 'center', sortable: false},
                    {text: 'Serial', value: 'serial', align: 'center', sortable: false},
                    // {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ],
                toBeDeleted: null,
                deleteDialog: false,
                editedItem: {
                    item_id	: null,
                    quantity: null,
                    serial: null,
                },
                default: {
                    item_id	: null,
                    quantity: null,
                    serial: null,
                }
            }
        },
        mounted() {
            this.getDepots();
            this.getClients();
        },
        computed: {
            show: {
                get() {
                    return this.createDispatchOrderDialog;
                },
                set(value) {
                    if (!value) this.$emit('close');
                }
            },
            showBis: {
                get() {
                    return this.itemsDialog;
                },
                set(value) {
                    if (!value) this.$emit('closeItem');
                }
            },
            renderedDispatchOrderItems() {
                if (this.GetDispatchOrderItems === null || this.GetDispatchOrderItems === undefined) {
                    return [];
                } else {
                    return this.GetDispatchOrderItems;
                }
            },
        },
        methods: {
            allowedMinutes: v => !(v % 30),
            updateDataTable() {
                this.reload = !this.reload;
            },
            // @vuese
            // Gets all the depots
            getDepots() {
                axios.get(process.env.API_URL + '/depots?wms=true')
                    .then((response) => {
                        this.depots = response.data;
                    })
                    .catch((response) => {
                         this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the clients
            getClients() {
                axios.get(process.env.API_URL + '/clients?active=true')
                    .then((response) => {
                        this.clients = Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the items
            getItems() {
                axios.get(process.env.API_URL + '/items?client=' + this.dispatchOrder.client_id)
                    .then((response) => {
                        this.items =  Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            newItem() {
                this.editedIndex = -1;
                this.editedItem = Object.assign({}, this.default);
                this.addItemDialog = true;
                this.getItems();
            },
            editRow(item) {
                this.editedItem = Object.assign({}, item);
                this.editedIndex = this.renderedDispatchOrderItems.indexOf(item);
                this.addItemDialog = true;
                this.getItems();
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            DeleteItem() {
                axios.delete(process.env.API_URL + '/dispatchorders/' + this.dispatchOrder.id + '/items/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.toBeDeleted = null;
                        this.deleteDialog = false;
                        this.$store.commit('displaySnackbar', "Delete successful");
                    })
                    .catch((error) => {
                        this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
                    });
                this.updateDataTable();
            },
            closeAddItemDialog() {
                this.editedIndex = -1;
                this.addItemDialog = false;
                this.editedItem = Object.assign({}, this.default);
            },
            saveChanges() {
                let body = {
                    item_id: this.editedItem.item_id,
                    quantity: this.editedItem.quantity,
                    serial: this.editedItem.serial,
                };

                if (this.editedIndex > -1) {
                    // EDIT
                    axios.put(process.env.API_URL + '/dispatchorders/' + this.dispatchOrder.id + '/item' + this.editedItem.id, this.editedItem)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Changes saved');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        });
                } else {
                    // CREATE
                    if (body.quantity === null) {
                        this.$store.commit('displaySnackbar', 'Please enter a quantity');
                        return false;
                    }

                    axios.post(process.env.API_URL + '/dispatchorders/' + this.dispatchOrder.id + '/item', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Create item successful');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Create item failed');
                        });
                }
                this.closeAddItemDialog();
            },
        },
        asyncComputed: {
            async GetDispatchOrderItems() {
                if (this.reload || !this.reload) {
                    if (this.dispatchOrder.id !== 0){
                        this.loading = true;
                        return await axios.get(process.env.API_URL + '/dispatchorders/' + this.dispatchOrder.id + '/items')
                            .then((response) => {
                                if (response.status === 200) {
                                    this.loading = false;
                                    return response.data;
                                } else {
                                    this.loading = false;
                                    return [];
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                return [];
                            });
                    }
                }
            },
        },
    }
</script>

<style scoped>
  .client-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/CreateDispatchOrder.vue